










































import { defineComponent } from "@vue/composition-api";
import VueCountryCode from "vue-country-code-select";
import { getElement } from "@/lib/elementHelpers";
import { $t } from "@/lib/i18nHelpers";
import BaseInput from "@/components/BaseInput";

export default defineComponent({
  name: "InputPhone",
  components: { BaseInput, VueCountryCode },
  props: {
    value: { type: String },
    name: { type: String, required: true },
    label: { type: String, default: $t("Phone number") },
    rules: { type: Array as () => string[], default: () => [] },
    validationMode: { type: String },
    countryCode: { type: Boolean },
  },
  data() {
    return {
      dialCode: "",
      inputValue: "",
      isTopDropdown: false,
    };
  },
  computed: {
    phoneRules(): string[] {
      return ["phone_length", ...this.rules];
    },
  },
  watch: {
    dialCode(newValue, oldValue) {
      if (oldValue) {
        this.inputValue = this.value?.replace("+" + oldValue, "") ?? "";
      }
      this.$emit("input", "+" + newValue + this.inputValue);
      getElement<HTMLInputElement>(this.$refs.input).focus();
    },
    value() {
      this.inputValue = this.value ?? "";
    },
  },
  mounted() {
    this.changeDropdownList();
    const inputScrollTop = getElement<HTMLInputElement>(this.$refs.input).getBoundingClientRect().bottom;
    const offsetBottom = window.innerHeight - inputScrollTop;
    if (offsetBottom < 200) this.isTopDropdown = true;
  },
  updated() {
    this.changeDropdownList();
  },
  methods: {
    onSelect({ dialCode }: { dialCode: string }) {
      this.dialCode = dialCode;
    },
    onInput(v: string, e: string) {
      this.inputValue = v;
      if (!this.inputValue.includes("+" + this.dialCode)) {
        this.inputValue = "+" + this.dialCode;
      }
      this.$emit("input", this.inputValue, e);
    },
    changeDropdownList() {
      const dropdownList = getElement<HTMLDivElement>(this.$refs.dropdown).querySelectorAll(".dropdown-item strong");
      dropdownList.forEach(i => {
        if (i.textContent) {
          i.textContent = i.textContent.replace(/\(.*\)/, "");
        }
      });
    },
  },
});
